import { ASSESSMENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/AssessmentOverview/questionnaireAnswer'
import { PATIENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/PatientOverview/questionnaireAnswer'
import { AUTHORIZATION_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/Authorization/questionnaireAnswer'
import { SERVICE_PLAN_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE as SERVICE_PLAN_SECTION_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/ServicePlan/questionnaireAnswer'
import { VISIT_SCHEDULING_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/VisitScheduling/questionnaireAnswer'
import { FINAL_STEPS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/FinalSteps/questionnaireAnswer'

export const SERVICE_PLAN_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  ...ASSESSMENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...PATIENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...AUTHORIZATION_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...SERVICE_PLAN_SECTION_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...VISIT_SCHEDULING_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...FINAL_STEPS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE
}
